import styled from 'styled-components';

import {
  green,
  blue,
  lightGreenSolid,
  lightGrayBackground,
  boxShadow1,
  border1,
} from 'utils/style/colors';

import Icon from 'components/Icon';
import Input from 'components/Input';
import Button from 'components/Button';
import HoverIcon from 'components/HoverIcon';
import { Box } from '../Inbox/styles';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CompanyMembersWrapper = styled('div')`
  flex: 1;
  display: flex;
  min-height: 0;
  flex-direction: column;
`;

export const CompanyMembersListWrapper = styled('ul')`
  flex: 1;
  overflow: auto;
  overflow: overlay;
`;

export const UserItemUp = styled('li')`
  display: flex;
  margin: 0 0.5rem 0 1rem;
  white-space: nowrap;
  align-items: center;
  cursor: pointer;
  justify-content: space-between;
  border-bottom: 1px solid darkgray;
`;
export const UserItemDown = styled('li')`
  display: flex;
  margin: 0 2rem 0.5rem;
  white-space: nowrap;
  align-items: center;
  justify-content: space-between;
  height: 46px;
`;

interface UsersContainerProps {
  isActive?: boolean;
}
export const UsersContainer = styled('div')<UsersContainerProps>`
  display: flex;
  flex-direction: column;
  padding: 10px;
  cursor: pointer;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const UserName = styled('span')`
  display: flex;
  // width: 14rem;
  align-items: center;
`;

export const RolesPart = styled('div')`
  margin: 0 10px 0 0;
  //overflow-x: overlay;
  overflow-y: hidden;
`;

export const RoleSelectContainer = styled('div')`
  flex: 0.8;
  display: flex;
`;

export const UserActionsContainer = styled('div')`
  width: 7rem;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
`;

export const IconsWrapper = styled('div')`
  display: flex;
  align-content: center;
`;

export const SearchPhoneNumberBox = styled('div')`
  margin: auto;
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
`;

export const SearchPhoneNumberContainer = styled('div')`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
`;

export const MembersCountInfo = styled('div')`
  left: 0;
  position: absolute;
  margin-left: 1.7rem;
  & > span:last-child {
    color: ${green};
    font-weight: 500;
  }
`;

export const CompanyMembersTabs = styled('div')`
  display: flex;
  margin-bottom: 1rem;
  justify-content: space-around;
`;

export const CompanyMembersFilterBox = styled('div')`
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  justify-content: space-around;
  gap: 10px;
  & > * {
    :nth-child(2) {
      flex: 1;
    }
    :nth-child(3) {
      flex: 1;
    }
  }
`;

export const CompanyMembersCount = styled('div')`
  width: 9rem;
  padding: 6px;
  margin: 15px 0;
  font-size: 14px;
  & > * {
    :last-child {
      font-weight: 500;
      color: ${green};
    }
  }
`;

export const inviteListFormStyle: React.CSSProperties = {
  flex: 1,
  overflow: 'auto',
  flexDirection: 'column',
};

export const InviteMemberViewsWrapper = styled('div')`
  flex: 1;
  overflow: auto;
  //overflow: overlay;
  padding-left: 1rem;
  flex-direction: column;
`;

export const SearchPhoneNumberInput = styled('input')`
  color: #344b47;
  font-weight: 400;
  border: ${border1} !important;
  height: 2.5rem !important;
  margin: 0 !important;
  padding: ${(props) =>
    props.theme.direction === 'rtl'
      ? '0 3rem 0 1rem'
      : '0 1rem 0 3rem'} !important;
  font-size: 14px !important;
  box-sizing: border-box !important;
  border-radius: 10px !important;
  background-color: white !important;
  &::placeholder {
    color: #96b1ac;
  }
  &:focus {
    border: 1px solid #34c8b6 !important;
    box-shadow: 0 0 2px #34c8b6 !important;
    background-color: var(--exact-white) !important;
  }
  &:hover {
    border: 1px solid #34c8b6 !important;
  }
`;

export const searchPhoneNumberMenuStyle: React.CSSProperties = {
  top: '2rem',
  left: '0',
  right: '2.5rem',
  width: 'initial',
  zIndex: 9999999999,
  display: 'flex',
  position: 'absolute',
  fontSize: '90%',
  overflow: 'auto',
  maxHeight: '12.5rem',
  background: 'var(--exact-white)',
  marginTop: '2px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
  borderRadius: '4px',
  flexDirection: 'column',
};

export const SearchIcon = styled(Icon)`
  color: var(--exact-white);
  cursor: pointer;
  height: 2.5rem;
  display: inline-flex;
  padding: 0.5rem;
  position: absolute;
  align-items: center;
  border-radius: ${(props) =>
    props.theme.direction === 'rtl' ? '0 6px 6px 0' : '6px 0 0 6px'};
  background-color: ${green};
`;

export const ClearInputIcon = styled(Icon)`
  color: #96b1ac;
  cursor: pointer;
  height: 2.5rem;
  z-index: 1;
  display: inline-flex;
  padding: 0.5rem;
  position: absolute;
  align-self: flex-end;
  align-items: center;
`;

export const InviteSearchLoadingStyle: React.CSSProperties = {
  left: '0.25rem',
  height: '2.5rem',
};

export const InviteMembersActions = styled('div')`
  display: flex;
  margin: 1rem 2.4rem 0 1rem;
  align-items: center;
  justify-content: space-between;
`;

export const InviteMembersButton = styled(Button)`
  flex: 1 !important;
`;

export const ForceRenameCheckBox = styled(Input)`
  margin-right: 2rem !important;
`;

export const MemberInviteInputsWrapper = styled('div')`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 2px 10px;
  & > * {
    :last-child {
      flex: 1;
    }
    min-width: 200px;
    :first-child {
      min-width: unset;
    }
  }
  background: ${lightGrayBackground};
  margin: 10px;
  border-radius: 10px;
  gap: 10px;
`;

export const DeleteMember = styled(HoverIcon)`
  align-self: center;
  margin-left: 0.8rem;
`;

export const InvitedMemberInfoContainer = styled('div')`
  overflow: auto;
  overflow: overlay;
`;

export const InvitedMemberInfoBox = styled('div')`
  color: ${blue};
  border: 1px solid ${blue};
  display: flex;
  padding: 0.6rem;
  font-weight: 400;
  align-items: center;
  border-radius: 10px;
  margin-bottom: 0.8rem;
  flex-direction: row;
`;

export const InvitedMemberInfoIcon = styled(Icon)`
  font-size: 13px;
  margin-left: 0.6rem;
`;

export const ProjectListWrapper = styled(Box)`
  width: 50%;
  overflow: auto;
  //overflow: overlay;
  max-height: calc(100vh - 300px);
  box-shadow: ${boxShadow1};
  border-radius: 10px;
  background-color: ${lightGreenSolid};
  position: relative;
  display: flex;
  flex-direction: column;
`;
